<template>
  <div class="conditon">
      <div class="conditon-item"  v-for="(item,index) in ConditionOption" :key="index">
          <div class="conditon-title">{{item.desc}}:</div>
          <div>
               <span :class="{'handleBtn':true, 'active':item.isActive == indexOne || childerItem.active}" v-for="(childerItem,indexOne) in item.list" :key="indexOne" @click="handle(item,index,indexOne)">{{childerItem.label}}<span v-if="childerItem.label == $t('other.a113') && item.desc==$t('other.a359')">({{item.list.length}})</span></span>
                <el-checkbox v-show="index == 2 && item.desc !== $t('other.a360')" style="padding:0 10px "  v-model="mutilChoose">{{$t('allorders.Themultiple')}}</el-checkbox>
                <!-- <el-button v-show="index == 2 && item.desc !== $t('other.a360')"  size="mini" type="primary"><i class="el-icon-plus"></i> {{$t('other.a361')}}</el-button> -->
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            activeList:[],
            multiShopList:[],
            mutilChoose:false,
            hiddenCode:false,
            allShopsList:[]
        }
    },
    props:{
        ConditionOption: {
            type: Array,
            default: []
        },
    },
    watch:{
        ConditionOption(){
            console.log(this.ConditionOption)
            this.ConditionOption.forEach(p => {
                if(p.desc === this.$t('other.a359')){
                    this.allShopsList=p.list
                }
            })

            console.log('11',this.allShopsList)
            
        },
    },
    created(){
        this.getCondition()
    },
    methods:{
        getCondition(){
            console.log(this.ConditionOption)
        },
        tbkf(index){
            if(this.multiShopList){
                return this.multiShopList.indexOf(index) > -1 ? true : false
            }else{
                return false
            }
        },
        handle(item,index,indexOne){
            console.log(item,index)
              console.log(this.ConditionOption)
              if(this.mutilChoose){//多选模式
              
                if(index == 2){
                    item.isActive=-1
                }else{
                    item.isActive=indexOne
                }

                this.multiShopList.push(indexOne)
                console.log(this.multiShopList)
                if(index == 2){
                    this.ConditionOption[2].list[indexOne].active=!this.ConditionOption[2].list[indexOne].active
                }
                console.log('41415',this.ConditionOption)
                this.$emit('getOrderParamsCopy',this.ConditionOption)
            }else{
                if(this.ConditionOption.length > 2){
                    this.ConditionOption[2].list.forEach(p => {
                        p.active=false
                    })
                }
                item.isActive=indexOne
                
                item.isActive=indexOne
                console.log('41415',this.ConditionOption)
                this.$emit('getOrderParams',this.ConditionOption)
            }
            
        }

    }
}

</script>
<style lang="scss" scoped>
.conditon{
    font-size: 17px;

    .conditon-item{
        display: flex;
        margin: 3px 0;
        line-height: 27px;
        padding: 7px 0;

        .conditon-title{
            min-width: 75px;
        }

        .handleBtn{
            font-size: 15px;
            display: inline-block;
            min-width: 60px;
            border:1px solid #d9d9d9;
            cursor: pointer;
            padding: 2px 6px;
            margin: 0 3px;
            text-align: center;
        }

        .active{
            background-color: #1890ff;
            color: #fff;
        }
    }

   
}
</style>